import { createAction } from 'Helpers';
import userTypes from './types';

const userActions = {
	forgetPasswordRequest: createAction(userTypes.FORGET_PASSWORD.REQUEST),
	forgetPasswordSuccess: createAction(userTypes.FORGET_PASSWORD.SUCCESS),
	forgetPasswordFailure: createAction(userTypes.FORGET_PASSWORD.FAILURE),
	forgetPasswordClear: createAction(userTypes.FORGET_PASSWORD.CLEAR),

	resetPasswordRequest: createAction(userTypes.RESET_PASSWORD.REQUEST),
	resetPasswordSuccess: createAction(userTypes.RESET_PASSWORD.SUCCESS),
	resetPasswordFailure: createAction(userTypes.RESET_PASSWORD.FAILURE),

	selectBusiness: createAction(userTypes.SESSION.SELECT_BUSINESS),

	userLogout: createAction(userTypes.SESSION.LOGOUT),

	profileRequest: createAction(userTypes.PROFILE.REQUEST),
	profileSuccess: createAction(userTypes.PROFILE.SUCCESS),
	profileFailure: createAction(userTypes.PROFILE.FAILURE),

	updateUserInfo: createAction(userTypes.UPDATE_PROFILE.REQUEST),
	updateUserInfoSuccess: createAction(userTypes.UPDATE_PROFILE.SUCCESS),

	profileUpdateRequest: createAction(userTypes.PROFILE_UPDATE.REQUEST),
	profileUpdateSuccess: createAction(userTypes.PROFILE_UPDATE.SUCCESS),
	profileUpdateFailure: createAction(userTypes.PROFILE_UPDATE.FAILURE),
	profileUpdateClear: createAction(userTypes.PROFILE_UPDATE.CLEAR),

	profileGetRequest: createAction(userTypes.GET_PROFILE.REQUEST),
	profileGetSuccess: createAction(userTypes.GET_PROFILE.SUCCESS),
	profileGetFailure: createAction(userTypes.GET_PROFILE.FAILURE),
	profileGetClear: createAction(userTypes.GET_PROFILE.CLEAR),

	profileUpdateOTPRequest: createAction(userTypes.CHANGE_NUMBER_OTP.REQUEST),
	profileUpdateOTPSuccess: createAction(userTypes.CHANGE_NUMBER_OTP.SUCCESS),
	profileUpdateOTPFailure: createAction(userTypes.CHANGE_NUMBER_OTP.FAILURE),
	profileUpdateOTPClear: createAction(userTypes.CHANGE_NUMBER_OTP.CLEAR),

	profileUpdateOTPConfirmRequest: createAction(
		userTypes.CHANGE_NUMBER_OTP_CONFIRM.REQUEST
	),
	profileUpdateOTPConfirmSuccess: createAction(
		userTypes.CHANGE_NUMBER_OTP_CONFIRM.SUCCESS
	),
	profileUpdateOTPConfirmFailure: createAction(
		userTypes.CHANGE_NUMBER_OTP_CONFIRM.FAILURE
	),
	profileUpdateOTPConfirmClear: createAction(
		userTypes.CHANGE_NUMBER_OTP_CONFIRM.CLEAR
	),

	profileWizardRequest: createAction(userTypes.WIZARD.REQUEST),
	profileWizardSuccess: createAction(userTypes.WIZARD.SUCCESS),
	profileWizardFailure: createAction(userTypes.WIZARD.FAILURE),
	profileWizardClear: createAction(userTypes.WIZARD.CLEAR),

	registerFreshRequest: createAction(userTypes.REGISTER_FRESH.REQUEST),
	registerFreshSuccess: createAction(userTypes.REGISTER_FRESH.SUCCESS),
	registerFreshFailure: createAction(userTypes.REGISTER_FRESH.FAILURE),
	registerFreshClear: createAction(userTypes.REGISTER_FRESH.CLEAR),
};

export default userActions;
